
import Colors from 'assets/Colors';

function EyeHideIcon({
  color = Colors.background_dividers,
  size = '18',
  style = {},
}) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 22 18"
      fill="none"
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.18939 1.07589C5.47631 0.777139 5.95109 0.767548 6.24984 1.05447L20.3026 14.5508C20.6014 14.8377 20.6109 15.3125 20.324 15.6112C20.0371 15.91 19.5623 15.9195 19.2636 15.6326L17.9942 14.4135C16.0356 16.1275 13.6239 17.1546 11 17.1546C6.95743 17.1546 3.43702 14.7249 1.27043 11.1007C0.736479 10.2075 0.736475 9.10531 1.27042 8.21213C2.55952 6.05576 4.32344 4.32521 6.39588 3.27447L5.21081 2.13633C4.91207 1.84941 4.90248 1.37464 5.18939 1.07589ZM14.1884 10.7584L16.9077 13.3701C15.2066 14.8237 13.1717 15.6546 11 15.6546C7.60161 15.6546 4.51932 13.612 2.55791 10.331C2.30732 9.91186 2.30732 9.40098 2.55791 8.9818C3.82583 6.86085 5.56735 5.25403 7.55357 4.38631L9.83412 6.57655C9.74657 6.60768 9.66012 6.6424 9.575 6.68068C8.91256 6.97862 8.36307 7.47835 8.0148 8.10997C7.6662 8.74218 7.5401 9.46924 7.65859 10.1799C7.77704 10.8902 8.13227 11.5391 8.66405 12.0306C9.19536 12.5216 9.87439 12.8296 10.5971 12.9136C11.3198 12.9976 12.0529 12.8537 12.6866 12.5009C13.3207 12.1478 13.8239 11.6026 14.114 10.9427C14.1408 10.8819 14.1656 10.8204 14.1884 10.7584ZM12.8777 9.4996L11.1971 7.88558C10.8527 7.85136 10.5042 7.90748 10.1903 8.04868C9.81635 8.21686 9.51564 8.49459 9.32835 8.83425C9.14139 9.17333 9.0757 9.55858 9.13817 9.93318C9.20068 10.3081 9.38933 10.6584 9.68214 10.929C9.97542 11.2 10.3569 11.3756 10.7702 11.4236C11.1837 11.4717 11.6006 11.3887 11.9569 11.1903C12.3127 10.9922 12.5859 10.6916 12.7409 10.3389C12.8583 10.072 12.9043 9.78397 12.8777 9.4996ZM13.2042 3.14479C13.3344 2.75159 13.7587 2.5384 14.1519 2.66863C16.8537 3.56347 19.149 5.56819 20.7296 8.21206C21.1355 8.89106 21.2337 9.69277 21.0201 10.4328C20.9052 10.8308 20.4895 11.0603 20.0915 10.9454C19.6936 10.8305 19.4641 10.4148 19.5789 10.0168C19.6778 9.67424 19.6336 9.30213 19.4421 8.98173C18.0133 6.59177 15.9842 4.85561 13.6803 4.09257C13.2871 3.96233 13.0739 3.538 13.2042 3.14479Z"
      />
    </svg>
  );
}

export default EyeHideIcon;
